import HighestPackageIcon from  "assets/images/tokens/highestPackage.svg";
import LowestPackageIcon from  "assets/images/tokens/lowestPackage.svg";
import TierOne from  "assets/images/tokens/tier1.svg";
import TierTwo from  "assets/images/tokens/tier2.svg";
import TierThree from  "assets/images/tokens/tier3.svg";
import TierFour from  "assets/images/tokens/tier4.svg";

export const bundleMap = {
    "Bundle 1": LowestPackageIcon,
    "Bundle 2": TierOne,
    "Bundle 3": TierTwo,
    "Bundle 4": TierThree,
    "Bundle 5": TierFour,
    "Bundle 6": HighestPackageIcon,
}